import * as actionTypes from './actionTypes';

// Load feedback filters from localStorage
const loadFeedbackFiltersFromStorage = () => {
  try {
    const stored = localStorage.getItem('feedbackFilters');
    if (stored) {
      return JSON.parse(stored);
    }
  } catch (error) {
    console.error('Error loading feedback filters from localStorage:', error);
  }
  return null;
};

// Save feedback filters to localStorage
const saveFeedbackFiltersToStorage = (filters) => {
  try {
    localStorage.setItem('feedbackFilters', JSON.stringify(filters));
  } catch (error) {
    console.error('Error saving feedback filters to localStorage:', error);
  }
};

const storedFilters = loadFeedbackFiltersFromStorage();

const initialState = {
  loading: false,
  redirect_to_login: false,
  page_no: (storedFilters && storedFilters.page_no) || 1,
  limit: (storedFilters && storedFilters.limit) || 10,
  search_keyword: (storedFilters && storedFilters.search_keyword) || '',
  filter_type: (storedFilters && storedFilters.filter_type) || '',
  filter_status: (storedFilters && storedFilters.filter_status) || '',
  page_no_1: 1,
  limit_1: 10,
  search_keyword_1: '',
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_REDRECT_TO_LOGIN_TRUE:
      return {
        ...state,
        redirect_to_login: true,
      };
    case actionTypes.SET_REDRECT_TO_LOGIN_FALSE:
      return {
        ...state,
        redirect_to_login: false,
      };
    case actionTypes.START_LOADER:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.STOP_LOADER:
      return {
        ...state,
        loading: false,
      };
    case actionTypes.SET_PAGE_NO:
      {
        const newState = {
          ...state,
          page_no: action.page_no,
        };
        saveFeedbackFiltersToStorage({
          page_no: newState.page_no,
          limit: newState.limit,
          search_keyword: newState.search_keyword,
          filter_type: newState.filter_type,
          filter_status: newState.filter_status,
        });
        return newState;
      }
    case actionTypes.SET_PAGE_LIMIT:
      {
        const newState = {
          ...state,
          limit: action.limit,
        };
        saveFeedbackFiltersToStorage({
          page_no: newState.page_no,
          limit: newState.limit,
          search_keyword: newState.search_keyword,
          filter_type: newState.filter_type,
          filter_status: newState.filter_status,
        });
        return newState;
      }
    case actionTypes.SET_SEARCH_KEYWORD:
      {
        const newState = {
          ...state,
          search_keyword: action.search_keyword,
        };
        saveFeedbackFiltersToStorage({
          page_no: newState.page_no,
          limit: newState.limit,
          search_keyword: newState.search_keyword,
          filter_type: newState.filter_type,
          filter_status: newState.filter_status,
        });
        return newState;
      }
    case actionTypes.SET_SEARCH_KEYWORD_1:
      return {
        ...state,
        search_keyword_1: action.search_keyword_1,
      };
    case actionTypes.SET_FILTER_TYPE:
      {
        const newState = {
          ...state,
          filter_type: action.filter_type,
        };
        saveFeedbackFiltersToStorage({
          page_no: newState.page_no,
          limit: newState.limit,
          search_keyword: newState.search_keyword,
          filter_type: newState.filter_type,
          filter_status: newState.filter_status,
        });
        return newState;
      }
    case actionTypes.SET_FILTER_STATUS:
      {
        const newState = {
          ...state,
          filter_status: action.filter_status,
        };
        saveFeedbackFiltersToStorage({
          page_no: newState.page_no,
          limit: newState.limit,
          search_keyword: newState.search_keyword,
          filter_type: newState.filter_type,
          filter_status: newState.filter_status,
        });
        return newState;
      }
    case actionTypes.SET_PAGE_NO_1:
      return { ...state, page_no_1: action.page_no_1 };

    case actionTypes.SET_PAGE_LIMIT_1:
      return { ...state, limit_1: action.limit_1 };
    case actionTypes.RESET_LISTING_STATES:
      {
        const newState = {
          ...state,
          page_no: 1,
          limit: 10,
          search_keyword: '',
          filter_type: '',
          filter_status: '',
        };
        saveFeedbackFiltersToStorage({
          page_no: newState.page_no,
          limit: newState.limit,
          search_keyword: newState.search_keyword,
          filter_type: newState.filter_type,
          filter_status: newState.filter_status,
        });
        return newState;
      }
    default:
      return state;
  }
};

export default reducer;
